module.exports = __webpack_public_path__ + "static/media/GroupOverhead.92a8ffa9.svg";